// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.templates-list-modal {
  padding-bottom: 32px !important;
}
.templates-list-modal .modal-body .templates-group {
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1019607843);
  border-radius: 8px;
  margin-top: 16px;
}
.templates-list-modal .modal-body .templates-group .templates-group__header {
  padding: 13px 24px;
  background-color: var(--secondary-surface, #f9fafb);
  border-bottom: 1px solid var(--Secondary-base, #eaecf0);
}
.templates-list-modal .modal-body .templates-group .templates-group__header .templates-group__header__title {
  font-size: 14px;
}
.templates-list-modal .modal-body .templates-group .templates-group__list .templates-group__item {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 10px 24px;
  background-color: #fff;
  border-bottom: 1px solid var(--Secondary-base, #cbd2e0);
}
.templates-list-modal .modal-body .templates-group .templates-group__list .templates-group__item .templates-group__item__title {
  display: inline-flex;
  align-items: center;
  word-break: break-all;
  margin-right: 10px;
}
.templates-list-modal .modal-body .templates-group .templates-group__list .templates-group__item:nth-last-child(1) {
  border-radius: 8px;
}
.templates-list-modal .modal-body .templates-group .templates-group__list .templates-group__item .templates-group__item__actions {
  display: flex;
}
.templates-list-modal .modal-body .templates-group .templates-group__list .templates-group__item .templates-group__item__actions .apply-button {
  padding: 4px 18px;
  height: fit-content;
}
.templates-list-modal .modal-body .templates-group .templates-group__list .templates-group__item .templates-group__item__actions .action-button {
  vertical-align: middle;
  margin-top: 0px !important;
  margin-left: 12px;
}

.template-updated-alert {
  width: max-content;
  right: 80px;
}
.template-updated-alert .Toastify__toast-body {
  font-size: 18px;
  color: var(--Secondary-eading, #101828);
  font-weight: 600;
}
.template-updated-alert .Toastify__toast-body .Toastify__toast-icon {
  margin-right: 40px;
}
.template-updated-alert .close-alert-btn {
  margin: 0 10px;
}
.template-updated-alert .close-alert-btn:hover {
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/pages/cna/assignments/unit/components/templates-list-modal/styles.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;AACF;AACI;EACE,yBAAA;EACA,0DAAA;EACA,kBAAA;EACA,gBAAA;AACN;AACM;EACE,kBAAA;EACA,mDAAA;EACA,uDAAA;AACR;AACQ;EACE,eAAA;AACV;AAIQ;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,uDAAA;AAFV;AAIU;EACE,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AAFZ;AAKU;EACE,kBAAA;AAHZ;AAMU;EACE,aAAA;AAJZ;AAMY;EACE,iBAAA;EACA,mBAAA;AAJd;AAOY;EACE,sBAAA;EACA,0BAAA;EACA,iBAAA;AALd;;AAcA;EAWE,kBAAA;EACA,WAAA;AArBF;AAUE;EACE,eAAA;EACA,uCAAA;EACA,gBAAA;AARJ;AAUI;EACE,kBAAA;AARN;AAeE;EAKE,cAAA;AAjBJ;AAaI;EACE,YAAA;AAXN","sourcesContent":[".templates-list-modal {\n  padding-bottom: 32px !important;\n  .modal-body {\n    .templates-group {\n      border: 1px solid #eaecf0;\n      box-shadow: 0px 1px 3px 0px #1018281a;\n      border-radius: 8px;\n      margin-top: 16px;\n\n      .templates-group__header {\n        padding: 13px 24px;\n        background-color: var(--secondary-surface, #f9fafb);\n        border-bottom: 1px solid var(--Secondary-base, #eaecf0);\n\n        .templates-group__header__title {\n          font-size: 14px;\n        }\n      }\n\n      .templates-group__list {\n        .templates-group__item {\n          display: flex;\n          justify-content: space-between;\n          font-size: 14px;\n          padding: 10px 24px;\n          background-color: #fff;\n          border-bottom: 1px solid var(--Secondary-base, #cbd2e0);\n\n          .templates-group__item__title {\n            display: inline-flex;\n            align-items: center;\n            word-break: break-all;\n            margin-right: 10px;\n          }\n\n          &:nth-last-child(1) {\n            border-radius: 8px;\n          }\n\n          .templates-group__item__actions {\n            display: flex;\n\n            .apply-button {\n              padding: 4px 18px;\n              height: fit-content;\n            }\n\n            .action-button {\n              vertical-align: middle;\n              margin-top: 0px !important;\n              margin-left: 12px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.template-updated-alert {\n  .Toastify__toast-body {\n    font-size: 18px;\n    color: var(--Secondary-eading, #101828);\n    font-weight: 600;\n\n    .Toastify__toast-icon {\n      margin-right: 40px;\n    }\n  }\n\n  width: max-content;\n  right: 80px;\n\n  .close-alert-btn {\n    &:hover {\n      opacity: 0.3;\n    }\n\n    margin: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
